<template>
  <v-container fill-height v-if="localLoading">
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
        <div class="text-h5 mt-4">Cargando información...</div>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="preaspirante">
    <v-row>
      <v-col cols="12">
        <v-btn @click="$router.go(-1)" text color="secondary">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver al catálogo
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="5">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Captura de foto</v-card-title>
          <v-card-text>
            <v-form v-model="capturaFotoForm">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :value="getFullName(preaspirante)"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Aspirante"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="fecha"
                      v-mask="'##/##/####'"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      :rules="dateRules"
                      hint="Formato de fecha: DD/MM/YYYY"
                    >
                      <template v-slot:label>Fecha de captura <span class="red--text">*</span> </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="file"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      :rules="nameRules"
                      prepend-icon=""
                      prepend-inner-icon="mdi-camera"
                      accept="image/*"
                      @change="onFileSelected"
                    >
                      <template v-slot:label>Adjuntar fotografía <span class="red--text">*</span> </template>
                    </v-file-input>
                  </v-col>
                  <v-col cols="12" v-if="previewUrl">
                    <v-img :src="previewUrl" contain max-height="200" class="rounded-lg"></v-img>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones"
                      no-resize
                      rows="4"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-6 ui-module-actions">
            <v-btn
              color="secondary"
              class="px-8 ui-module-btn-solid"
              :disabled="!capturaFotoForm || loading"
              :loading="loading"
              v-on:click="triggerSaveBiometrico()"
              >Registrar</v-btn
            >
          </v-card-actions>
        </v-card>

        <v-card class="ui-module-card mt-6" color="primary" v-if="biometricosFoto.length > 0">
          <v-card-title class="font-weight-bold ui-module-titlebar">
            <v-icon color="secondary" class="mr-2">mdi-camera</v-icon>
            Capturas registradas
          </v-card-title>
          <v-card-text>
            <v-list color="transparent">
              <v-list-item v-for="b in biometricosFoto" :key="b.idBiometricoPersonal">
                <v-list-item-icon>
                  <v-icon color="secondary">mdi-image</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium text--primary">{{ b.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{ b.fechaRealizacion }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip small :color="b.url ? 'success' : 'warning'" outlined>
                    {{ b.url ? 'Archivo disponible' : 'Sin archivo' }}
                  </v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  beforeDestroy() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
  },

  async mounted() {
    this.localLoading = true
    this.SET_PREASPIRANTE_PARA_VALIDACION(this.id)

    if (!this.preaspirante) {
      this.isPersonal = true
      try {
        await this.fetchPersonalById(this.id)
        if (this.personalSingle) {
          this.SET_PREASPIRANTE_PARA_VALIDACION_DIRECT(this.personalSingle)
        } else {
          this.SET_SNACKBAR_MESSAGE('No se pudo encontrar la información del personal.')
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al obtener la información del personal.')
      }
    }

    if (this.id) {
      await this.fetchBiometricosPersonal(this.id)
    }

    this.localLoading = false
  },

  data() {
    return {
      loading: false,
      localLoading: false,
      capturaFotoForm: false,
      menu: false,
      isPersonal: false,

      observaciones: '',
      fecha: null,
      file: null,
      nombre: null,
      previewUrl: null,

      nameRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => !v || v.type.startsWith('image/') || 'Solo se permiten archivos de imagen (jpg, png, etc.)',
      ],
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, this.API_DATE_FORMAT)
          return moment(date, this.API_DATE_FORMAT).isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirante: 'getPreaspiranteParaValidacion',
    }),
    ...mapGetters('personal', {
      personalSingle: 'getPersonalSingle',
    }),
    ...mapGetters('biometrico', {
      biometricosPersonal: 'getBiometricosPersonal',
    }),

    biometricosFoto() {
      return this.biometricosPersonal.filter((b) => b.tipoBiometrico && b.tipoBiometrico.id === 3)
    },
  },

  methods: {
    ...mapActions('biometrico', ['saveBiometricoPersonal', 'fetchBiometricosPersonal']),
    ...mapActions('preaspirante', ['fetchPreaspirantes']),
    ...mapActions('personal', ['fetchPersonalById']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('preaspirante', ['SET_PREASPIRANTE_PARA_VALIDACION', 'SET_PREASPIRANTE_PARA_VALIDACION_DIRECT']),

    triggerSaveBiometrico: async function () {
      this.loading = true

      try {
        await this.saveBiometricoPersonal({
          nombre: this.file.name,
          fk_idPersonal: this.id,
          fk_idTipoBiometrico: 3,
          observaciones: this.observaciones,
          fechaRealizacion: this.fecha,
          file: this.file,
        })

        if (this.isPersonal) {
          this.$router.push({ name: 'personalPersonal' })
        } else {
          await this.fetchPreaspirantes()
          this.$router.push({ name: 'Preaspirantes' })
        }
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al guardar el registro biométrico. Verifica el archivo e intenta de nuevo.')
      } finally {
        this.loading = false
      }
    },

    onFileSelected(file) {
      if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
      this.previewUrl = file ? URL.createObjectURL(file) : null
    },

    saveBirthdayDate: function (date) {
      this.$refs.menu.save(date)
    },
  },
}
</script>

